import Upper from './module/upper'
import Creative from './module/creative'
import UniteOrder from './module/uniteOrder'
import Account from './module/account'
import Help from './module/help'
import Qualification from './module/qualification'
import AgentData from './module/agent-data'
import Finance from './module/finance'
import Qifei from './module/qifei'
import CaseReport from './module/case-report'
import Market from './module/market'
import Crowd from './module/crowd'
import List from './module/list'
import AppPackage from './module/app-package'
import MyGame from './module/my-game'
import WechatGame from './module/wechat-game'
import LandingPage from './module/landing-page'
import College from './module/college'
import Favorites from './module/favorites'
import Opportunity from './module/opportunity'

export default [].concat(
  Upper,
  Creative,
  Account,
  WechatGame,
  Help,
  Qualification,
  Finance,
  UniteOrder,
  AgentData,
  Qifei,
  CaseReport,
  Market,
  Crowd,
  List,
  AppPackage,
  College,
  MyGame,
  LandingPage,
  Favorites,
  Opportunity
)
